import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { OrderPublic } from '../../../../globalTypes/order.types';
import { CommonModule, CurrencyPipe, DatePipe, JsonPipe } from '@angular/common';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { Store } from '@ngrx/store';
import { accountFeature } from '../../store/account.store';
import { takeUntil } from 'rxjs';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { Fulfillment, FulfillmentStatusType } from '../../../../globalTypes/fulfillment.types';
import { ButtonComponent, ButtonDisplay } from "../../component/layout/element/button.component";
import { NameTagComponent } from "../../component/layout/element/name.tag.component";
import { dateTimeFormat, Status } from '../../../../globalTypes/base.types';
import { Router, RouterLink } from "@angular/router";
import { getOverlap, getRotation, getZIndex } from '../../helper/general';
import { AccountService } from '../../services/account.service';
import { ReviewForEdit } from '../../../../globalTypes/review.types';
import { RatingComponent } from "../../component/review/rating.component";
import { LOCATION_LABEL } from '../../../../globalTypes/configs';

@Component({
  selector: 'msh-purchase-order-entry',
  imports: [CurrencyPipe, DatePipe, CommonModule, ButtonComponent, NameTagComponent, RatingComponent],
  template: `
@if(order){
<div class="relative border-b border-navy/25 pt-8 px-6 rounded pb-8 hover:bg-copy/5 cursor-pointer " (click)="viewPurchase()">
  <div class="md:flex gap-12">
    <div>
      <div class=" uppercase font-extrabold text-xl">Order #{{order.orderNumber}}</div>
      <div class=" text-sm mt-2 font-thin">
          {{order.createdAt | date:dateTimeFormat}}
      </div>
      <div class="flex items-center flex-wrap">
        <div class="mt-4 mb-4 flex items-center justify-center">
          @for(item of order.orderItems_on_order; track item.id; let i = $index){
            <div 
              class="  w-16 h-16 bg-back flex justify-center items-center mr-6 rounded overflow-hidden bg-white"
              [ngClass]="[
                getOverlap(i),
                getZIndex(i),
                getRotation(i)
              ]"
            >
              <img [src]="item.listingVariation.image.url" />
            </div>
          }
        </div>
        <div class="md:hidden flex flex-wrap">
          @for(fulfillment of order.fulfillments_on_order; track fulfillment.id; let locIdx = $index){
            @if(fulfillment.statusId !== 'archived'){
              <div class="mt-3">
                <msh-name-tag
                  [size]="'small'"
                  [label]="locations[fulfillment.fulfilledByLocationId].name"
                  [url]="locations[fulfillment.fulfilledByLocationId].profileImage?.url"
                ></msh-name-tag>
              </div>
            }
          }
        </div>
        <div class=" font-thin">@if(order.orderItems_on_order && order.orderItems_on_order.length; as num){ {{num}} item{{ num===1?'':'s'}}}</div>
      </div>
      <div class=" uppercase text-xs font-bold">Transaction #<div class="text-xs opacity-50 font-thin">{{order.paymentTransactionId}}</div></div>
      
    </div>
    <div class="grow flex flex-col">
      <div class="grid grid-cols-3 font-bold mt-10 md:mt-0">
        <div class="hidden md:flex capitalize ">{{LOCATION_LABEL}}s</div>
        <div>Shipments</div>
        <div></div>
      </div>
      @for(fulfillment of order.fulfillments_on_order; track fulfillment.id; let ffIdx = $index){
        @if(fulfillment.statusId !== 'archived'){
          
            <div class="grid grid-cols-3 py-2 ">
              <div class="hidden md:flex">
                  <msh-name-tag
                    [size]="'small'"
                    [label]="locations[fulfillment.fulfilledByLocationId].name"
                    [url]="locations[fulfillment.fulfilledByLocationId].profileImage?.url"
                  ></msh-name-tag>
              </div>
              <div class="flex justify-between flex-wrap col-span-2 gap-3">
                <div>
                  <div class=" items-center flex gap-2 grow mb-4">
                    <div class=" font-medium">Fulfillment #{{fulfillment.fulfillmentNumber}}</div>
                    <div class="text-orange-400 col-span-2">{{!!fulfillmentStatusMap[fulfillment.statusId] ? fulfillmentStatusMap[fulfillment.statusId].description : fulfillment.statusId}}</div>
                  </div>  
                  @if(fulfillment.refunds_on_fulfillment && fulfillment.refunds_on_fulfillment.length){     
                    <div class="mb-4">
                      @for(refund of fulfillment.refunds_on_fulfillment; track refund.id){
                        <div class="flex items-center gap-2">
                          <div class="text-sm text-orange-400">{{!!fulfillmentStatusMap[refund.statusId] ? fulfillmentStatusMap[refund.statusId].description : refund.statusId}}</div>
                          <div class="text-xs font-thin">{{refund.amount | currency}}</div>
                        </div>
                      }
                    </div>
                  }  
                  @if(buyerReviews[fulfillment.id]){
                    <div class="flex gap-2 text-sm text-copy/50">Your Review: 
                      <msh-rating [small]="true" [rating]="buyerReviews[fulfillment.id].rating" [readonly]="true"></msh-rating>
                    </div>
                  }
                  @if(sellerReviews[fulfillment.id]){
                    <div class="flex gap-2 text-sm text-copy">Seller Review: 
                      <msh-rating [small]="true" [rating]="sellerReviews[fulfillment.id].rating" [readonly]="true"></msh-rating>
                    </div>
                  }
                </div>                
                <div class="">
                  @if(fulfillment.statusId && ctaMap[fulfillment.statusId]){
                    <msh-button (onClick)="actionButtonClicked(fulfillment)" [isLoading]="takingAction" class="relative top-2" 
                    [optionData]="{fulfillment, order}" [buttonDisplayMap]="ctaMap[fulfillment.statusId]"></msh-button>
                  }
                </div>
              </div>
            </div>
        <!-- @if(order.orderItems_by_fulfillment && order.orderItems_by_fulfillment[fulfillment.id]; as items){
          @for(item of items; track item.id; let itemIdx = $index){
          }
        } -->
        }
      }
    </div>
  </div>
  <div class="absolute right-6 top-8  uppercase font-extrabold text-lg">{{order.totalAmount | currency}}</div>

</div>
}
  `,
  styles: ``
})
export class PurchaseOrderEntryComponent extends Base<PurchaseOrderEntryComponent> {

  @Input() fulfillmentStatusMap: {[statusId: string]: Status} = {}
  @Input() ctaMap!:  {[status in FulfillmentStatusType]?: ButtonDisplay }
  @Input() takingAction = false;
  @Input() buyerReviews: {[fulfillmentId: string]: ReviewForEdit} = {};
  @Input() sellerReviews: {[fulfillmentId: string]: ReviewForEdit} = {}
  @Output() onActionTaken: EventEmitter<Fulfillment> = new EventEmitter();
  dateTimeFormat = dateTimeFormat;
  locations: {[locationId: string]: LocationPublic} = {}; 
  ctasThatNeedButtons: string[] = []
  getZIndex = getZIndex
  getRotation = getRotation
  getOverlap = getOverlap
  LOCATION_LABEL = LOCATION_LABEL;


  @Input() order!: OrderPublic 
  constructor(
    private store: Store,
    private router: Router,
  ){
    super();
    this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy)).subscribe(async locations => {
      this.locations = locations as {[locationId:string]: LocationPublic}
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['order']){
      if(this.order && this.order.orderItems_by_location){
        console.log({order: this.order});
      }
    }
  }

  actionButtonClicked(fulfillment: Fulfillment){
    this.onActionTaken.emit(fulfillment)
  }

  viewPurchase(){
    this.router.navigate(['/order','purchase',this.order.id])
  }

}
